// extracted by mini-css-extract-plugin
export default {"chetNechet":"HW4_chetNechet__5xJGw"};